// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"c2c5efa1","403":"fd9f2ff9","576":"1a67253d","789":"ca74a488","950":"1c014582"}[chunkId] + ".css";
};